import { render, staticRenderFns } from "./DocumentMediaExtractionDlg.vue?vue&type=template&id=d9a52a2c&scoped=true&"
import script from "./DocumentMediaExtractionDlg.vue?vue&type=script&lang=ts&"
export * from "./DocumentMediaExtractionDlg.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentMediaExtractionDlg.vue?vue&type=style&index=0&id=d9a52a2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a52a2c",
  null
  
)

export default component.exports